import { CheckCircle2, Play, Wrench } from "lucide-react";

export const StatusBadge = ({ status, testId }) => {
  const done = status === "Completed";
  return (
    <span
      data-testid={testId}
      className={`font-sub inline-flex items-center gap-1.5 rounded-sm px-2.5 py-1 text-xs font-semibold uppercase tracking-wider ${
        done ? "bg-[#F4EFE6] text-[#121214]" : "bg-[#FFD23F] text-[#121214]"
      }`}
    >
      {done ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Wrench className="h-3.5 w-3.5" />}
      {done ? "Completed" : "In Progress"}
    </span>
  );
};

export const SampleBadge = ({ testId }) => (
  <span
    data-testid={testId}
    className="font-sub inline-flex items-center rounded-sm border border-[#F4EFE6]/50 bg-[#121214]/80 px-2 py-1 text-[11px] font-semibold uppercase tracking-widest text-[#F4EFE6]"
  >
    Sample
  </span>
);

export const PlayOverlay = ({ small = false }) => (
  <span className="pointer-events-none absolute inset-0 grid place-items-center" data-testid="play-icon-overlay">
    <span
      className={`grid place-items-center rounded-full bg-[#FFD23F] text-[#121214] shadow-[0_0_30px_rgba(0,0,0,0.6)] ${
        small ? "h-11 w-11" : "h-16 w-16"
      }`}
    >
      <Play className={small ? "ml-0.5 h-5 w-5" : "ml-1 h-7 w-7"} fill="currentColor" />
    </span>
  </span>
);
